import PayError from '../component/payError';

export default (props) => {
  return <PayError {...props} />;
};
